<button
  [type]="type"
  [class]="buttonClasses"
  [disabled]="disabled || loading"
  [pTooltip]="tooltip"
  [tooltipPosition]="tooltipPosition"
  (click)="onClick($event)"
>
  <span class="vb-btn__content">
    @if (loading) {
      <i class="vb-btn__spinner pi pi-spinner pi-spin"></i>
    } @else if (icon && iconPos === 'left') {
      <i class="vb-btn__icon vb-btn__icon--left" [ngClass]="icon"></i>
    }

    @if (label) {
      <span class="vb-btn__label">{{ label }}</span>
    }

    @if (!loading && icon && iconPos === 'right') {
      <i class="vb-btn__icon vb-btn__icon--right" [ngClass]="icon"></i>
    }
  </span>
</button>
